import { useState, useEffect } from 'react';
import { useQuery } from 'urql';

import type { InstagramCreatorFilter } from '@frontend/gql/social/graphql';
import { suggestInstagramCreatorFilter } from '../graphql';

interface UseSuggestedInstagramCreatorFilterReturn {
  suggestedFilter: InstagramCreatorFilter | null;
  isLoading: boolean;
  error: Error | null;
  generateFilter: (prompt: string) => void;
}

export const useSuggestedInstagramCreatorFilter = (): UseSuggestedInstagramCreatorFilterReturn => {
  const [prompt, setPrompt] = useState<string | null>(null);
  const [suggestedFilter, setSuggestedFilter] = useState<InstagramCreatorFilter | null>(null);
  const [error, setError] = useState<Error | null>(null);

  const [{ data, fetching, error: queryError }] = useQuery({
    query: suggestInstagramCreatorFilter,
    variables: { prompt: prompt || '' },
    pause: !prompt, // Only run when prompt is provided
  });

  useEffect(() => {
    if (data?.suggestInstagramCreatorFilter?.filter) {
      setSuggestedFilter(data.suggestInstagramCreatorFilter.filter);
      setError(null);
    } else if (queryError) {
      console.error('Error getting suggested filter:', queryError);
      setError(new Error('Failed to generate suggested filter'));
      setSuggestedFilter(null);
    }
  }, [data, queryError]);

  const generateFilter = (newPrompt: string) => {
    setError(null);
    setPrompt(newPrompt);
  };

  return {
    suggestedFilter,
    isLoading: fetching,
    error,
    generateFilter,
  };
};
